<h3>{{ "HängigeGeogeschäfte" | translate }}</h3>

<cap-list-loader [hasRight]="hasRight" [listLoader]="haengigeLoader">
  <div class="cap-list-loader-content">
    <table [attr.aria-label]="'HängigeGeogeschäfte' | translate" class="cap-table-detail">
      <thead>
        <ng-template [ngTemplateOutlet]="tableHeaders"></ng-template>
      </thead>
      <tbody>
        <ng-template [ngTemplateOutlet]="tableRows"></ng-template>
      </tbody>
    </table>
  </div>
</cap-list-loader>

<ng-template #tableHeaders>
  <tr>
    <th class="noselect" style="cursor: pointer; width: 15%">
      <cap-column-header [columnName]="'Nummer'" [sortModel]="tableSortModel.columns.get('nummer')"></cap-column-header>
    </th>
    <th class="noselect" style="cursor: pointer; width: 10%">
      <cap-column-header [columnName]="'DatumAuftrag'" [sortModel]="tableSortModel.columns.get('auftragsDatum')"></cap-column-header>
    </th>
    <th class="noselect" style="width: 25%">
      {{ "Beschreibung" | translate }}
    </th>
  </tr>
</ng-template>

<ng-template #tableRows>
  @for (geschaeft of haengigeLoader?.items; track geschaeft.id.id) {
    @let geschaeftId = geschaeft.id.id;
    <tr>
      <td>
        <cap-kompakt-geometergeschaeft
          [canViewGeoGeschaeftDetails]="false"
          [item]="geschaeft.geometergeschaeft"></cap-kompakt-geometergeschaeft>
      </td>
      <td>
        <cap-link [enableNavigation]="false" [params]="[geschaeftId]" [target]="navTargets.NAV_GEOMETERGESCHAEFT">
          {{ geschaeft.auftragsDatum | datum }}
        </cap-link>
      </td>
      <td>
        @if (geschaeft.mBeschreibung.access !== "NONE") {
          <span>
            <cap-link [enableNavigation]="false" [params]="[geschaeftId]" [target]="navTargets.NAV_GEOMETERGESCHAEFT">{{
              geschaeft.beschreibung
            }}</cap-link>
          </span>
        }
        @if (geschaeft.mBeschreibung.access === "NONE") {
          <span>{{ "gemaessGrundbuch" | translate }}</span>
        }
      </td>
    </tr>
  }
</ng-template>
